import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./ListStyles.css";
import useAxios from "./useAxios";
import useSessionStorage from "./useSessionStorage";

const StreamTypesList = ({ logout }) => {
  const navigate = useNavigate();
  const [axios] = useAxios(true, logout);
  const [tenant] = useSessionStorage("tenant");

  const [streamTypes, setStreamTypes] = useState([]);

  useEffect(() => {
    axios.get("streamtypes", setStreamTypes);
  }, []);

  return (
    <div className="list-container">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
          marginBottom: 24,
        }}
      >
        <h2 style={{ margin: 0 }}>Stream Types</h2>
        <button
          className="edit-button"
          aria-label="Add New Stream Type"
          style={{
            fontSize: 24,
            padding: "4px 14px",
            margin: 0,
            lineHeight: 1,
          }}
          onClick={() => navigate("/configuration/streamtype/new")}
        >
          +
        </button>
      </div>
      <table className="list-table">
        <thead>
          <tr>
            {tenant.super ? <th>Tenant</th> : null}
            <th>Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {streamTypes.map((streamType) => (
            <tr key={streamType.id}>
              {tenant.super ? <td>{streamType.tenant?.name}</td> : null}
              <td>{streamType.name}</td>
              <td>
                <button
                  className="edit-button"
                  onClick={() =>
                    navigate("/configuration/streamtype/" + streamType.id)
                  }
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StreamTypesList;
